export enum EnumSimulatedCallStep {
  start = 'SIMULATED_CALL_START',
  inProgress = 'SIMULATED_CALL_IN_PROGRESS',
  complete = 'SIMULATED_CALL_COMPLETE'
}

export enum EnumActionType {
  message = 'message', // Simple Message: Sends a message/attachment
  gate = 'gate', // Gated: Sends message, waits for response. Technically superfluous now.
  collect = 'collect', // Collect Info
  question = 'question',
  data = 'data',
  delay = 'delay',
  call = 'call',
  webhook = 'webhook',
  route = 'route',
  pollingLocator = 'pollingLocator',
  mobilizeEventLocator = 'mobilizeEventLocator'
}

export enum EnumNudgeTriggerActionType {
  noCall = 'no_call',
  noLinkClick = 'no_link_click',
  noResponse = 'no_response',
  linkClicked = 'link_clicked',
  linkClickedNoDonation = 'link_clicked_no_donation',
  linkClickedNoFormSubmission = 'link_clicked_no_form_submission'
}

export enum EnumNudgeTrackFormType {
  actionKitPage = 'AK_PAGE',
  actionNetworkForm = 'AN_FORM',
  actionNetworkLetterCampaign = 'AN_LETTER_CAMPAIGN',
  actionNetworkPetition = 'AN_PETITION',
  everyActionEvent = 'EA_EVENT',
  everyActionOnlineAction = 'EA_ONLINE_ACTION',
  facebookLeadAd = 'FB_LEAD',
  mobilizeEvent = 'MOBILIZE_EVENT',
  controlShiftPetition = 'CONTROLSHIFT_PETITION'
}

export enum EnumNudgeErrorMessageType {
  defaultValue = 'DEFAULT_VALUE',
  flagCallImmediate = 'FLAG_CALL_IMMEDIATE_FLAG',
  flagCsvLookupTypeField = 'FLAG_CSV_LOOKUP_TYPE_FIELD',
  flagSendAndHold = 'FLAG_SEND_AND_HOLD',
  missingCallNumber = 'MISSING_CALL_NUMBER',
  missingMessage = 'MISSING_MESSAGE',
  missingTrackForm = 'MISSING_TRACK_FORM',
  missingTrackUrl = 'MISSING_TRACK_URL',
  missingTriggerAction = 'MISSING_TRIGGER_ACTION'
}

export enum EnumIGActionType {
  message = 'message', // Simple Message: Sends a message/attachment
  collect = 'collect', // Collect Info
  question = 'question'
}

export enum EnumOfficeLevel {
  federal = 'FEDERAL',
  state = 'STATE'
}

export enum EnumChamber {
  lower = 'LOWER',
  upper = 'UPPER'
}

export enum EnumMemberDonationFilter {
  between = 'donated between',
  byBroadcast = 'donated by broadcast',
  on = 'donated on',
  notOn = 'has not donated on',
  before = 'donated before',
  notBefore = 'has not donated before',
  after = 'donated after',
  notAfter = 'has not donated after',
  inTheLast = 'donated in the last',
  notInTheLast = 'has not donated in the last',
  olderThan = 'donation older than',
  daysAgo = 'donated days ago',
  notDaysAgo = 'has not donated days ago'
}

export enum EnumCsvResultStatus {
  complete = 'Complete',
  formatting = 'Formatting',
  importing = 'Importing',
  uploading = 'Uploading'
}

export enum EnumApiMethod {
  delete = 'DELETE',
  get = 'GET',
  post = 'POST',
  put = 'PUT'
}

export enum EnumMessageType {
  Text = 'text', // Message is in UTF-8.
  HexEncoded = 'hexEncodedText', // Message is hex encoded.
  Binary = 'binary', // Message is binary content.
  WAP = 'wapPush' // Message is a WAP Push.
}

export enum EnumTon {
  LongCode = 1, // A toll-free number, long code, VMN or landline
  ShortCode = 3, // A short code
  Alphanumeric = 5 // An alphanumeric string
}
